import React from 'react';
import './IncomeInfoSection.css';
import GrossYearlyIncomeWrapper from '../../SharedComponents/GrossYearlyIncomeWrapper';

function IncomeInfoSection({dispatch, customerData, appConfig}) {
  return (
    <GrossYearlyIncomeWrapper dispatch={dispatch} customerData={customerData}/>
  );
}

export default IncomeInfoSection;
